module.exports = __webpack_public_path__ + "img/profile-art-2.8529f63.svg";